import { useEffect, useState } from "react";

/** How long "Yes, send it" ignores taps after it appears. */
const ARM_DELAY_MS = 600;

export interface SendConfirm {
  /** The "Send to 14 people now?" box is showing. */
  armed: boolean;
  /** The arming delay has passed, so "Yes, send it" can be pressed. */
  ready: boolean;
  arm: () => void;
  disarm: () => void;
}

/**
 * Arming a send to everyone used to swap the confirm button into the
 * exact place the arming button had been, so an ordinary double tap
 * emailed every guest. The confirm ignores taps for a moment after it
 * appears: long enough for the second tap of a double tap to land
 * harmlessly, short enough that a deliberate yes feels instant.
 */
export function useSendConfirm(): SendConfirm {
  const [armed, setArmed] = useState(false);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (!armed) {
      setReady(false);
      return;
    }
    const timer = setTimeout(() => setReady(true), ARM_DELAY_MS);
    return () => clearTimeout(timer);
  }, [armed]);
  return {
    armed,
    ready,
    arm: () => setArmed(true),
    disarm: () => setArmed(false),
  };
}
